"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:7.3.0'] && _();
}
catch (e) { }
